import { render, staticRenderFns } from "./sign-attribute.vue?vue&type=template&id=5d6bdfe0&scoped=true&"
import script from "./sign-attribute.vue?vue&type=script&lang=ts&"
export * from "./sign-attribute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6bdfe0",
  null
  
)

export default component.exports